import { IAppState } from 'models/app.model'

export const DuplicateNFTsSelector = (state: IAppState) => state.duplicateNFTs
